import React from 'react';
import { Box, Typography } from '@mui/material';

// One title treatment for every page: a quiet eyebrow, the name in Fraunces,
// an optional line of context, and the page's actions on the right.
// Pages differed in weight, size and spacing before this existed.
const PageHeader = ({ eyebrow, title, subtitle, actions, accent }) => (
  <Box
    sx={{
      display: 'flex',
      alignItems: { xs: 'stretch', sm: 'flex-end' },
      justifyContent: 'space-between',
      flexDirection: { xs: 'column', sm: 'row' },
      gap: 2,
      mb: 3,
    }}
  >
    <Box sx={{ minWidth: 0 }}>
      {eyebrow && (
        <Typography variant="overline" display="block" sx={{ color: accent }}>
          {eyebrow}
        </Typography>
      )}
      <Typography variant="h3" sx={{ lineHeight: 1.15 }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography variant="body2" color="text.secondary" sx={{ mt: 0.75 }}>
          {subtitle}
        </Typography>
      )}
    </Box>
    {actions && (
      <Box sx={{ display: 'flex', gap: 1.5, flexShrink: 0, flexWrap: 'wrap' }}>
        {actions}
      </Box>
    )}
  </Box>
);

export default PageHeader;
